module.exports = __webpack_public_path__ + "img/e3e35fcc0f46d6ed1fbc85ed1ac20695.edfea610.png";